<template>
<el-dialog class="acceptProposal" :visible.sync="dialogVisible" top="0" :before-close="closeModal" width="620px">
    <div class="w-100">
        <div class="pt-5 px-5">
            <div class="d-flex justify-content-center mb-2">
                <AlertExclamationRegister />
            </div>
            <h3 class="c-ndarkthree bold mb-2 text-center">
                Deseja alterar o status desta empresa?
            </h3>
        </div>
    </div>    
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <router-link :class="`${getPrimaryColor} mr-4 c-ndarkfour`" to="" @click.native="closeModal()">
            Cancelar
        </router-link>

        <Button @click="updateStatus()" :color="getPrimaryColor">
            Ok, atualizar
        </Button>
    </span>
</el-dialog>
</template>

<script>
import AlertExclamationRegister from '@/components/icons/AlertExclamationRegister'
export default {
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
    },
    components: {
        AlertExclamationRegister,
    },
    methods: {
        closeModal() {
            this.$emit('closeModal', false)
        },
        updateStatus() {
            this.$emit('updateStatus')
        }
    }

}
</script>

<style lang="scss">
</style>
